var React = require('react');

function IconUserInfoO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M663.8 434c0-71.5-58-129.5-129.5-129.5s-129.5 58-129.5 129.5c0 57.1 37 105.6 88.3 122.8-75.5 21.1-131.4 98.2-131.4 179.3H707c0-81.1-56-158.2-131.4-179.3 51.2-17.2 88.2-65.7 88.2-122.8zM157.5 293.7h-37.1v-72.9h37.1V64.2l735.3.7c8.1 0 14.7 6.6 14.7 18.1v865.2c0 4.8-6.6 11.4-14.7 11.4H157.5V736.2h-36.7v-73.9h36.7V515h-36.7v-74.9h36.7V293.7zm78.9 592.2l580.2-.8c8.1 0 14.7-6.6 14.7-14.7V154.6c0-8.1-6.6-14.7-14.7-14.6l-580.2-.3V885.9z"}));
}

IconUserInfoO.displayName = "IconUserInfoO";

IconUserInfoO.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconUserInfoO;

IconUserInfoO.default = IconUserInfoO;
